import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavigationBarComp from './components/navigationBarComp';
import Home from './pages/home';
import About from './pages/about';
import SingleProduct from './pages/singleProduct';
import FooterComp from './components/footerComp';

function App() {
    return (
        <>
            <Router>
                <div>
                    <NavigationBarComp />
                </div>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/products/:productId" element={<SingleProduct />} />
                </Routes>

                <div>
                    <FooterComp />
                </div>
            </Router>
        </>
    );
}

export default App;
